'use client';

import { Typography } from '@musinsa/mds';
import { BankSelect, useBankSelectState } from '../../../common/components/BankSelect';

interface BankSelectFieldProps {
  value?: string;
  onChange?: (value: string) => void;
  error?: boolean;
  errorText?: string;
}

export const BankSelectField = ({
  value = '',
  onChange,
  error,
  errorText,
}: BankSelectFieldProps) => {
  // 상태는 부모(BankSelectField)에서 관리
  const {
    banks,
    error: bankError,
    selectedBank,
    isOpen,
    select,
    toggle,
    close,
  } = useBankSelectState({
    initialValue: value,
    currentValue: value, // 외부 value를 직접 전달
    onSelect: onChange,
  });

  return (
    <div className="flex flex-col gap-2">
      <BankSelect
        banks={banks}
        selectedBank={selectedBank}
        isOpen={isOpen}
        error={error || !!bankError}
        onToggle={toggle}
        onClose={close}
        onSelect={select}
      />

      {error && errorText && (
        <Typography variant="textEtc11pxReg" colorScheme="red">
          {errorText}
        </Typography>
      )}
    </div>
  );
};
